<div class="slide-form-field">
  <mat-slide-toggle color="{{color}}" [checked]="value" [required]="required" [disabled]="disabled" (change)="valueChanged($event)">{{label}}</mat-slide-toggle>
</div>
